import React from "react";
import { StyledFooter } from "./styled";

function Footer({ children }) {
  return <StyledFooter>{children}</StyledFooter>;
}

export default Footer;
